/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-02-26 13:24:52 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-08-15 19:15:55
 */

import axios from 'axios';

const apiServer = axios.create({
    baseURL: '/api/v1/', // http://localhost:7777
});

export function loadXls(filename, download = false) {
    return apiServer.get("packing-list/getFileStream/" + encodeURIComponent(filename), { responseType: download ? 'blob' : 'arraybuffer' }).then(res => {
        return download ? new Blob([res.data]) : new Uint8Array(res.data);
    });
}

export function loadRecognitionInfo(mailId) {
    return apiServer.get(`packing-list/getRecognitionInfo/${mailId}`);
}

export function loadFieldTypes() {
    return apiServer.get(`packing-list/fieldTypes`);
}

export function parseMailAttachments(mailId, attachments, force = false) {
    return apiServer.post(`packing-list/recognizeMailAttachments/${mailId}`, {
        mailId,
        attachments,
    }, {
        params: {
            force: force ? "" : undefined,
        }
    });
}



// WEBPACK FOOTER //
// ./app/services/packingList.js